import { Middleware } from "@reduxjs/toolkit";
import i18next from "i18next";
import { LanguageState } from "../../store/slices/languageSlice";

export const i18nMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  const state: LanguageState = store.getState().language;

  i18next.changeLanguage(state.language.toLowerCase()); // Sprache auf lowercase setzen

  return result;
};
